module.exports = __webpack_public_path__ + "static/media/tips_content.f97d12f7.md";